import { render, staticRenderFns } from "./SendingRecord.vue?vue&type=template&id=e440441c&scoped=true"
import script from "./SendingRecord.vue?vue&type=script&lang=js"
export * from "./SendingRecord.vue?vue&type=script&lang=js"
import style0 from "./SendingRecord.vue?vue&type=style&index=0&id=e440441c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e440441c",
  null
  
)

export default component.exports